import React from 'react';
import { CodIcon } from '../../static/svg/CodIcon';
import { FreeShipIcon } from '../../static/svg/FreeShipIcon';
import { SatisfactionIcon } from '../../static/svg/SatisfactionIcon';

const InnerShipping = () => {
  return (
    <>
      <section id="discover" className="w-full flex flex-wrap">
        <div className="xs:px-4 lg:px-0 relative w-full flex flex-col items-center justify-center lg:container lg:mx-auto py-8">
          <div className="w-full flex flex-row justify-between xs:items-start lg:items-center py-4 lg:-mx-5">
            <div className="xs:flex-1 lg:flex-none lg:w-48 lg:h-48 rounded-full lg:bg-customBackground-600 flex xs:items-start lg:content-center lg:items-center justify-center flex-wrap">
              <FreeShipIcon className="xs:w-8 xs:h-8 lg:w-10 lg:h-10" />
              <p className="xs:px-5 lg:px-0 w-full text-center xs:text-sm lg:text-lg capitalize mt-5">
                Free Shipping
              </p>
            </div>

            <div className="xs:flex-1 lg:flex-none lg:w-48 lg:h-48 rounded-full lg:bg-customBackground-600 flex xs:items-start lg:content-center lg:items-center justify-center flex-wrap">
              <CodIcon className="xs:w-8 xs:h-8 lg:w-10 lg:h-10" />
              <p className="w-full text-center xs:text-sm lg:text-lg capitalize mt-5">
                Cash On Delivery
              </p>
            </div>

            <div className="xs:flex-1 lg:flex-none lg:w-48 lg:h-48 rounded-full lg:bg-customBackground-600 flex xs:items-start lg:content-center lg:items-center justify-center flex-wrap">
              <SatisfactionIcon className="xs:w-8 xs:h-8 lg:w-10 lg:h-10" />
              <p className="w-full text-center xs:text-sm lg:text-lg capitalize mt-5">
                Satisfaction Guaranteed
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default InnerShipping;
